import VueCookie from 'vue-cookie'
import store from '@/store'
import {networkService as network} from '@/services'

export const eventService = {

  getEvents() {
    return new Promise((resolve, reject) => {
      network
        .get(`/events/all/en`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getEventLangAll() {
    return new Promise((resolve, reject) => {
      network
        .get(`/events/translations/all`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getEventLangAllIdx(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/events/translations/${id}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },


  getEvent({ eventId, locale = 'en' }) {
    return new Promise((resolve, reject) => {
      network
        .get(`/events/${eventId}?locale=${locale}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getRegisterUserEvent(id) {
    return new Promise((resolve, reject) => {
      network
          .get(`/user-events/all/event/${id}`)
          .then((data) => {
            resolve(data.data)
          })
          .catch((err) => {
            reject(err)

          })
    })
  },

  addEvent(payload) {
    return new Promise((resolve, reject) => {
      network
        .post(`/events`, payload)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  },

  addEventLogo(id, _file) {

    let formData = new FormData()
    formData.append("logo", _file)

    return new Promise((resolve, reject) => {
      network
        .post(`/events/logo/${id}`, formData)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  },

  addEventWithTranslations(payload) {
    return new Promise((resolve, reject) => {
      network
        .post(`/events/translations`, payload)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  },

  editEvent(payload) {
    return new Promise((resolve, reject) => {
      network
        .put(`/events/${payload.id}`, payload)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  },

  getEventRestrictions() {
    return new Promise((resolve, reject) => {
      network
        .get(`/event-restrictions/all/en`)
        .then((data) => {

          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  removeEvent(id) {
    return new Promise((resolve, reject) => {
      network
        .delete(`/events/${id}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

}
